var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_CheckSetting"),
        width: "800px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        "show-close": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-button",
        {
          attrs: { no: "confirm", type: "primary" },
          on: { click: _vm.addHandler }
        },
        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
      ),
      _c("cargo-ag-grid", {
        staticStyle: { height: "400px", "margin-top": "5px" },
        attrs: {
          "show-side-bar": false,
          "grid-options": _vm.gridOptions,
          "row-data": _vm.rowData,
          "column-defs": _vm.columnDefs,
          "check-sub-record": _vm.checkSubRecord,
          "deselect-sub-record": _vm.checkSubRecord
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.save }
            },
            [_vm._v(_vm._s(_vm.$t("common.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                  _vm.$emit("cancel", _vm.otherFieldBkg)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }